var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ec951a;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #323232;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m122.8,28.68c4.8,0,11-.27,11-6.67,0-5.81-5.53-6.61-10.07-6.61h-6v13.28h5.07Zm-13.48-20.49h15.88c9.14,0,17.42,3.21,17.42,13.68,0,11.88-8.88,14.02-18.89,14.02h-6v19.55h-8.41V8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m162.23,41.08h-1.66c-4.41,0-12.01.33-12.01,4.94,0,2.94,3,4.2,5.61,4.2,5.47,0,8.07-2.87,8.07-7.33v-1.8Zm.47,9.94h-.2c-2.27,3.61-6,5.21-10.28,5.21-5.94,0-11.67-3.27-11.67-9.62,0-10.4,12.14-11.14,20.15-11.14h2v-.86c0-3.94-3.07-6.01-7.34-6.01-3.34,0-6.41,1.34-8.54,3.34l-4.2-4.2c3.54-3.6,8.54-5.14,13.61-5.14,13.68,0,13.68,9.87,13.68,14.41v18.42h-7.21v-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m175.84,23.4h8.01v5.07h.13c1.74-3.67,5.28-5.87,9.48-5.87,1,0,1.94.2,2.87.47v7.74c-1.33-.33-2.6-.6-3.87-.6-7.54,0-8.6,6.33-8.6,8.07v17.15h-8.01V23.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m199.39,30.21v-6.81h6.61v-9.27h8.01v9.27h8.81v6.81h-8.81v14.01c0,3.2.94,5.2,4.48,5.2,1.4,0,3.33-.27,4.33-1v6.75c-1.66.8-4.47,1.07-6.33,1.07-8.47,0-10.48-3.81-10.48-11.34v-14.68h-6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m252.97,18.33c-1.79-2.53-5-3.73-8.27-3.73-3.87,0-7.74,1.74-7.74,6.08,0,9.47,22.42,4.06,22.42,20.88,0,10.14-8.01,15.07-17.28,15.07-5.87,0-11.61-1.8-15.48-6.41l6.34-6.13c2.07,3.13,5.61,4.94,9.34,4.94s8.27-2.14,8.27-6.47c0-10.35-22.42-4.41-22.42-21.29,0-9.74,8.68-14.28,17.42-14.28,4.94,0,9.87,1.41,13.54,4.87l-6.14,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m286.21,36.21c-.07-4.67-3.13-7.61-8.14-7.61-4.73,0-7.68,3.01-8.27,7.61h16.42Zm-16.42,6c.53,4.74,4.14,7.61,8.6,7.61,4.01,0,6.61-1.87,8.61-4.34l5.74,4.34c-3.73,4.61-8.47,6.41-13.55,6.41-9.67,0-17.41-6.74-17.41-16.82s7.74-16.81,17.41-16.81c8.94,0,15.02,6.28,15.02,17.42v2.2h-24.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 297.82,
    y: 4.99,
    width: 8.01,
    height: 50.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m333.85,36.21c-.06-4.67-3.13-7.61-8.14-7.61-4.73,0-7.68,3.01-8.27,7.61h16.42Zm-16.42,6c.53,4.74,4.14,7.61,8.61,7.61,4,0,6.6-1.87,8.6-4.34l5.74,4.34c-3.73,4.61-8.47,6.41-13.54,6.41-9.68,0-17.42-6.74-17.42-16.82s7.74-16.81,17.42-16.81c8.93,0,15.01,6.28,15.01,17.42v2.2h-24.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m368.55,33c-1.88-1.93-3.93-3.2-6.08-3.2-5.87,0-9.4,4.61-9.4,9.6s3.53,9.62,9.4,9.62c2.47,0,4.74-1.07,6.2-3.01l5.34,5.74c-3.27,3.27-8.74,4.48-11.54,4.48-9.67,0-17.41-6.74-17.41-16.82s7.74-16.81,17.41-16.81c4.07,0,8.54,1.47,11.61,4.87l-5.53,5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m375.08,30.21v-6.81h6.61v-9.27h8.01v9.27h8.81v6.81h-8.81v14.01c0,3.2.94,5.2,4.47,5.2,1.41,0,3.34-.27,4.34-1v6.75c-1.66.8-4.47,1.07-6.33,1.07-8.47,0-10.48-3.81-10.48-11.34v-14.68h-6.61Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.73,25.69l.21,29.67-38.79.02v-13.51h5.58c7.3,0,12.83-2.49,12.83-10.63s-5.98-10.52-13.18-10.52h-12.88v34.66H14.88s0-29.71,0-29.71H1.5L49.16.37l48.09,25.32h-13.52Zm-28.1,5.55c0-3.57-3.62-4.06-6.57-4.06h-3.91v8.23h5.08c2.7,0,5.39-.93,5.39-4.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartselect);
export default __webpack_public_path__ + "static/media/partselect.be1b61f976421c43873bf5b6c0841281.svg";
export { ForwardRef as ReactComponent };